import { render, staticRenderFns } from "./salesLeadPagination.vue?vue&type=template&id=4c12696e&scoped=true&"
import script from "./salesLeadPagination.vue?vue&type=script&lang=js&"
export * from "./salesLeadPagination.vue?vue&type=script&lang=js&"
import style0 from "./salesLeadPagination.vue?vue&type=style&index=0&id=4c12696e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c12696e",
  null
  
)

export default component.exports